/// <amd-module name="SuiteCommerce.GiftCertificate.ValueCheck.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.ValueCheck.View", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.Common.FeedbackMessageManager", "SuiteCommerce.GiftCertificate.ValueCheck.Configuration", "SuiteCommerce.GiftCertificate.ValueCheck.Model", "SuiteCommerce.GiftCertificate.ValueCheck.Form.View", "SuiteCommerce.GiftCertificate.ValueCheck.Result.View", "value_check.tpl"], function (require, exports, Backbone_1, FeedbackMessageManager_1, ValueCheck_Configuration_1, ValueCheck_Model_1, ValueCheck_Form_View_1, ValueCheck_Result_View_1, value_check_template) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ValueCheckView = exports.ExternalEnvironment = void 0;
    var ExternalEnvironment;
    (function (ExternalEnvironment) {
        ExternalEnvironment["SHOPPING"] = "shopping";
        ExternalEnvironment["MYACCOUNT"] = "my_account";
        ExternalEnvironment["CHECKOUT"] = "checkout";
    })(ExternalEnvironment || (exports.ExternalEnvironment = ExternalEnvironment = {}));
    var ErrorCode;
    (function (ErrorCode) {
        ErrorCode["DUPLICATED_GIFT_CERTIFICATE"] = "ERROR_CUSTOMER_ALREADY_HAS_GIFT_CERTIFICATE";
        ErrorCode["EXPIRED_GIFT_CERTIFICATE_CODE"] = "ERROR_GIFT_CERTIFICATE_EXPIRED";
        ErrorCode["INVALID_GIFT_CERTIFICATE_CODE"] = "ERROR_GIFT_CERTIFICATE_INVALID";
        ErrorCode["INACTIVE_GIFT_CERTIFICATE_CODE"] = "ERROR_GIFT_CERTIFICATE_INACTIVE";
    })(ErrorCode || (ErrorCode = {}));
    var ValueCheckView = /** @class */ (function (_super) {
        __extends(ValueCheckView, _super);
        function ValueCheckView(options) {
            var _a;
            var _this = _super.call(this, options) || this;
            _this.template = value_check_template;
            _this.ErrorCodeMessageTypeMap = (_a = {},
                _a[ErrorCode.DUPLICATED_GIFT_CERTIFICATE] = {
                    type: FeedbackMessageManager_1.FeedbackMessageType.INFO,
                    message: ValueCheck_Configuration_1.ValueCheckConfiguration.codeDuplicatedMessage,
                },
                _a[ErrorCode.EXPIRED_GIFT_CERTIFICATE_CODE] = {
                    type: FeedbackMessageManager_1.FeedbackMessageType.WARNING,
                    message: ValueCheck_Configuration_1.ValueCheckConfiguration.expiredCodeMessage,
                },
                _a[ErrorCode.INVALID_GIFT_CERTIFICATE_CODE] = {
                    type: FeedbackMessageManager_1.FeedbackMessageType.WARNING,
                    message: ValueCheck_Configuration_1.ValueCheckConfiguration.invalidCodeMessage,
                },
                _a[ErrorCode.INACTIVE_GIFT_CERTIFICATE_CODE] = {
                    type: FeedbackMessageManager_1.FeedbackMessageType.WARNING,
                    message: ValueCheck_Configuration_1.ValueCheckConfiguration.inactiveCodeMessage,
                },
                _a);
            _this.model = options.model;
            _this.container = options.container;
            _this.title = options.title;
            if (options.environment)
                _this.environment = options.environment;
            return _this;
        }
        Object.defineProperty(ValueCheckView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    ValueCheckForm: function () {
                        var valueCheckFormView = new ValueCheck_Form_View_1.ValueCheckFormView({
                            application: _this.container,
                            model: _this.model,
                            showFeedbackMessages: false,
                            showAddToMyAccountButtonAsLink: _this.environment === ExternalEnvironment.SHOPPING,
                            displayedInShopping: _this.environment === ExternalEnvironment.SHOPPING,
                            displayedInCheckout: _this.environment === ExternalEnvironment.CHECKOUT,
                            displayedInMyAccount: _this.environment === ExternalEnvironment.MYACCOUNT,
                        });
                        _this.model.on('change:id change:status', function () {
                            _this.onValueCheckFormSyncModel();
                        });
                        _this.model.on('sync', function () {
                            _this.onValueCheckFormSyncModel();
                        });
                        _this.model.on(ValueCheck_Form_View_1.ValueCheckModelSubmittedEvent, function () {
                            return _this.onValueCheckFormSubmittedModel();
                        });
                        _this.model.on(ValueCheck_Form_View_1.ValueCheckModelSubmittingErrorEvent, function (response) {
                            return _this.onValueCheckFormErrorSubmittingModel(response);
                        });
                        return valueCheckFormView;
                    },
                    ValueCheckResult: function () {
                        var valueCheckResultView = new ValueCheck_Result_View_1.ValueCheckResultView({
                            application: _this.container,
                            model: _this.model,
                            showCheckAnotherGiftCertificateLink: false,
                        });
                        _this.model.on('change:id change:status', function () {
                            var status = _this.model.get('status');
                            if (status === ValueCheck_Model_1.GiftCertificateStatus.active ||
                                status === ValueCheck_Model_1.GiftCertificateStatus.expired) {
                                valueCheckResultView.render();
                                valueCheckResultView.$el
                                    .find('.gift-certificate-balance-main-result')
                                    .removeClass('hide');
                            }
                            else {
                                valueCheckResultView.$el
                                    .find('.gift-certificate-balance-main-result')
                                    .addClass('hide');
                            }
                        });
                        return valueCheckResultView;
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        ValueCheckView.prototype.onValueCheckFormSyncModel = function () {
            var status = this.model.get('status');
            if (status === ValueCheck_Model_1.GiftCertificateStatus.invalid) {
                FeedbackMessageManager_1.FeedbackMessageManager.triggerMessageEvent({
                    context: this,
                    type: this.ErrorCodeMessageTypeMap[ErrorCode.INVALID_GIFT_CERTIFICATE_CODE].type,
                    message: this.ErrorCodeMessageTypeMap[ErrorCode.INVALID_GIFT_CERTIFICATE_CODE].message,
                });
            }
            else if (status === ValueCheck_Model_1.GiftCertificateStatus.inactive) {
                FeedbackMessageManager_1.FeedbackMessageManager.triggerMessageEvent({
                    context: this,
                    type: this.ErrorCodeMessageTypeMap[ErrorCode.INACTIVE_GIFT_CERTIFICATE_CODE].type,
                    message: this.ErrorCodeMessageTypeMap[ErrorCode.INACTIVE_GIFT_CERTIFICATE_CODE].message,
                });
            }
            else {
                FeedbackMessageManager_1.FeedbackMessageManager.triggerRemoveMessageEvent(this);
            }
        };
        ValueCheckView.prototype.onValueCheckFormSubmittedModel = function () {
            FeedbackMessageManager_1.FeedbackMessageManager.triggerMessageEvent({
                context: this,
                type: FeedbackMessageManager_1.FeedbackMessageType.SUCCESS,
                message: ValueCheck_Configuration_1.ValueCheckConfiguration.codeSavedMessage,
            });
        };
        ValueCheckView.prototype.onValueCheckFormErrorSubmittingModel = function (response) {
            var errorCode = response.responseJSON && response.responseJSON.error
                ? response.responseJSON.error
                : '';
            if (errorCode && this.ErrorCodeMessageTypeMap[errorCode]) {
                FeedbackMessageManager_1.FeedbackMessageManager.triggerMessageEvent({
                    context: this,
                    type: this.ErrorCodeMessageTypeMap[errorCode].type,
                    message: this.ErrorCodeMessageTypeMap[errorCode].message,
                });
            }
            else {
                FeedbackMessageManager_1.FeedbackMessageManager.triggerMessageEvent({
                    context: this,
                    type: FeedbackMessageManager_1.FeedbackMessageType.WARNING,
                    message: ValueCheck_Configuration_1.ValueCheckConfiguration.generalWarning,
                });
            }
        };
        ValueCheckView.prototype.getContext = function () {
            return {
                title: this.title,
            };
        };
        return ValueCheckView;
    }(Backbone_1.View));
    exports.ValueCheckView = ValueCheckView;
});
